import { useEffect } from "react";

type TerminalPleaseWaitPopupProps = {
    showPopup: boolean;
    onCancel: () => void;
    timeLeft: number
}

export const TerminalPleaseWaitPopup = ({ showPopup, onCancel, timeLeft }: TerminalPleaseWaitPopupProps) => {


    const formatTime = (seconds: number) => {
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
    };

    useEffect(() => {
        if (showPopup) {
            document.body.classList.add("overflow-hidden");
        } else {
            document.body.classList.remove("overflow-hidden");
        }

        return () => {
            document.body.classList.remove("overflow-hidden");
        };
    }, [showPopup]);


    if (!showPopup) return null;

    return (
        <div className="fixed inset-0 z-[9999999] flex items-center justify-center bg-black/50">
            <div className="w-[380px] max-w-[90%] rounded-2xl bg-white p-6 shadow-xl flex flex-col items-center text-center">

                {/* Spinner */}
                <div className="mb-4 h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-primary" />

                {/* Title */}
                <h2 className="text-lg font-semibold text-gray-800 mb-1">
                    Waiting for Payment
                </h2>

                {/* Instruction Message */}
                <p className="text-sm text-gray-600 mb-4">
                    Please complete the payment using the card terminal device.
                    Do not close or refresh this page until the transaction finishes.
                </p>

                {/* Timer */}
                <div className="mb-5 rounded-lg bg-gray-100 px-4 py-2">
                    <p className="text-sm font-medium text-gray-700">
                        Time remaining: <span className="text-primary font-semibold">{formatTime(timeLeft)}</span>
                    </p>
                </div>

                {/* Cancel Button */}
                <button
                    type="button"
                    className="w-full rounded-lg border border-red-500 px-4 py-2 text-sm font-medium text-red-600 hover:bg-red-50 transition"
                    onClick={onCancel}
                >
                    Cancel Payment
                </button>
            </div>
        </div>

    )
}